import React from 'react';
import Button from '../../../shared/components/Button';

interface MaintenancePublicPageProps {
  message: string | null;
  onOpenLogin: () => void;
}

/**
 * Écran plein page quand la maintenance est active : message + accès connexion CM uniquement (vérifié côté API).
 */
const MaintenancePublicPage: React.FC<MaintenancePublicPageProps> = ({
  message,
  onOpenLogin,
}) => {
  return (
    <section className="relative z-10 min-h-[70vh] flex flex-col items-center justify-center px-6 py-16">
      <div className="max-w-lg w-full rounded-2xl border border-amber-500/40 bg-gray-900/80 backdrop-blur-md shadow-2xl p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-500/20 border border-amber-400/50 mb-6">
          <span className="text-3xl" aria-hidden>
            ⚙️
          </span>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-white mb-3">
          Maintenance en cours
        </h1>
        <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-2">
          {message?.trim()
            ? message
            : 'OpSecours est momentanément indisponible. Nous revenons très bientôt.'}
        </p>
        <p className="text-amber-200/90 text-sm mb-8 border-t border-amber-500/20 pt-6">
          Seul le <strong className="text-amber-100">Founder</strong> peut se
          connecter pendant cette période pour gérer le site ou désactiver la maintenance.
        </p>
        <Button variant="primary" size="lg" onClick={onOpenLogin} className="w-full min-h-[48px]">
          Connexion Founder
        </Button>
        <p className="mt-4 text-xs text-gray-500">
          Les autres comptes ne peuvent pas se connecter tant que la maintenance est active.
        </p>
      </div>
    </section>
  );
};

export default MaintenancePublicPage;
